import PropTypes from 'prop-types';
import Image from 'next/image';
import PaymentIcon from '@material-ui/icons/Payment';
import { useTranslation } from 'react-i18next';
import useGetVehicle from '../hooks/useGetVehicle';
import CustomButton from './CustomButton';
import { useState } from 'react';
import SeparateDialog from './SeparateDialog';

const getIcon = (type) => {
  switch (type) {
    case 'mercadolibre':
      return <Image src="/mercadolibre-icon.png" alt="mercadolibre" width="25" height="20" />;
    default:
      return <PaymentIcon />;
  }
};

const getButtonType = (separateUrl) => {
  if (separateUrl.includes('mercadolibre.com')) return 'mercadolibre';

  return 'primary';
};

const SeparateButton = ({ className }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const { t } = useTranslation('details');
  const { vehicle } = useGetVehicle();
  const type = getButtonType(vehicle.separateUrl || '');

  // if (!vehicle.separateUrl) return null;

  const actionProps = {};

  if (vehicle.separateUrl) {
    actionProps.href = vehicle.separateUrl;
  } else {
    actionProps.onClick = () => setOpenDialog(true);
  }

  return (
    <div>
      <CustomButton
        id="separateButton"
        className={className}
        variant="contained"
        size="large"
        color={type}
        target="_blank"
        startIcon={getIcon(type)}
        onClick={() => setOpenDialog(true)}
      >
        {t('Separate')}
      </CustomButton>
      {openDialog && <SeparateDialog handleCancel={() => setOpenDialog(false)} />}
    </div>
  );
};

SeparateButton.propTypes = {
  className: PropTypes.string,
};

SeparateButton.defaultProps = {
  className: '',
};

export default SeparateButton;
